import Controller from '@ember/controller'
import { service } from '@ember/service'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import type { IntlService } from 'ember-intl'
import type SubscriptionTypeService from 'teacher-ui-client/services/subscription-type'
import type RolloverStudentImportService from 'teacher-ui-client/services/rollover-student-import'
import type RouterService from '@ember/routing/router-service'
import type StudentCsvMaker from 'teacher-ui-client/services/student-csv-maker'

export default class StudentsStepIndexController extends Controller {
  @service intl!: IntlService

  @service subscriptionType!: SubscriptionTypeService

  @service rolloverStudentImport!: RolloverStudentImportService

  @service router!: RouterService

  @service studentCsvMaker!: StudentCsvMaker

  get currentSubscriptionType(): SubscriptionType {
    return this.subscriptionType.current
  }

  get hasSuccessfulImport() {
    return Boolean(this.rolloverStudentImport.importJob?.imported)
  }

  get iconColorClass() {
    const baseClass = 'h-6 w-6'

    return {
      [SubscriptionType.Reading]: `text-oceany-blue-350 ${baseClass}`,
      [SubscriptionType.Maths]: `text-ms-green-300 ${baseClass}`,
      [SubscriptionType.Writing]: baseClass,
    }[this.currentSubscriptionType]
  }

  downloadRolloverCsv = () => {
    const filename = this.intl.t('manage.rollover.steps.students.export.filename')
    void this.studentCsvMaker.downloadRolloverCsv.perform(filename)
  }

  /**
   * Hands the csv `File` to the rollover student importer service for uploading to the validate endpoint.
   * @param {Event} event
   */
  selectCsvFile = (event: Event) => {
    const file = event.target instanceof HTMLInputElement ? event.target.files?.[0] : null
    if (file) {
      this.rolloverStudentImport.setFile(file)
      void this.router.transitionTo('manage.rollover.steps.students.import.validate')
    }
  }

  get studentExampleTableData() {
    const { intl } = this
    const keyPrefix = 'manage.rollover.steps.students.howToEdit.exampleTable'

    const defaultColumn = {
      classNames: 'bg-white border border-dusty-black-200 p-2 font-bold',
      cellClassNames: 'bg-white border border-dusty-black-200 p-2',
    }

    const columns = [
      `${keyPrefix}.fields.studentId`,
      `${keyPrefix}.fields.firstName`,
      `${keyPrefix}.fields.lastName`,
      `grade.label`,
      `${keyPrefix}.fields.teacherEmail`,
      `${keyPrefix}.fields.externalId`,
    ].map((key) => {
      return { ...defaultColumn, value: intl.t(key) }
    })

    const studentText = intl.t(`${keyPrefix}.cells.student`)
    const oneText = intl.t(`${keyPrefix}.cells.one`)
    const twoText = intl.t(`${keyPrefix}.cells.two`)
    const threeText = intl.t(`${keyPrefix}.cells.three`)
    const fourText = intl.t(`${keyPrefix}.cells.four`)

    const rows = [
      [{ value: 1234 }, { value: studentText }, { value: oneText }, { value: 2 }, { value: ' ' }, { value: 9638 }],
      [{ value: 2345 }, { value: studentText }, { value: twoText }, { value: 2 }, { value: ' ' }, { value: 8460 }],
      [{ value: 3456 }, { value: studentText }, { value: threeText }, { value: 2 }, { value: ' ' }, { value: 7854 }],
      [{ value: 4567 }, { value: studentText }, { value: fourText }, { value: 2 }, { value: ' ' }, { value: 6897 }],
    ].map((cells) => ({ cells }))

    return { rows, columns }
  }
}
